import { render, staticRenderFns } from "./EmojiPicker.vue?vue&type=template&id=370bfa09&scoped=true"
import script from "./EmojiPicker.vue?vue&type=script&lang=js"
export * from "./EmojiPicker.vue?vue&type=script&lang=js"
import style0 from "./EmojiPicker.vue?vue&type=style&index=0&id=370bfa09&prod&scoped=true&lang=less"
import style1 from "./EmojiPicker.vue?vue&type=style&index=1&id=370bfa09&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "370bfa09",
  null
  
)

export default component.exports